import { render, staticRenderFns } from "./DialogAddFolder.vue?vue&type=template&id=4de859f4"
import script from "./DialogAddFolder.vue?vue&type=script&lang=js"
export * from "./DialogAddFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports